












































import { computed, defineComponent } from '@nuxtjs/composition-api'
import { format } from '~/utils/date'
import { ciVerifiedBadge } from '~/icons/source/solid/verified-badge'
import { ciCheck } from '~/icons/source/solid/check'
import { ciInfoCircle } from '~/icons/source/solid/info-circle'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  props: {
    seller: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { locale } = useI18n()

    const telephoneVerified = computed(
      () => props.seller?.verification?.telephoneVerified || false
    )
    const creditCardVerified = computed(
      () => props.seller?.verification?.creditCardVerified || false
    )
    const userSince = computed(() => {
      return format(props.seller.verification.userSince, 'dd-MM-yyyy', {
        locale
      })
    })

    return {
      ciCheck,
      ciInfoCircle,
      ciVerifiedBadge,
      telephoneVerified,
      creditCardVerified,
      userSince
    }
  }
})
